<!-- Navbar -->
<nav class="sv-nav d-flex align-items-center justify-content-between px-4 px-md-5">
  <div class="d-flex align-items-center gap-2">
    <svg width="30" height="30" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 2L35.5885 11V29L20 38L4.41154 29V11L20 2Z" stroke="#d59448" stroke-width="2.5"/>
      <circle cx="20" cy="20" r="4" fill="#d59448"/>
      <path d="M20 10V14" stroke="#d59448" stroke-width="2"/>
      <path d="M20 26V30" stroke="#d59448" stroke-width="2"/>
      <path d="M28.6603 15L25.1962 17" stroke="#d59448" stroke-width="2"/>
      <path d="M14.8038 23L11.3397 25" stroke="#d59448" stroke-width="2"/>
      <path d="M28.6603 25L25.1962 23" stroke="#d59448" stroke-width="2"/>
      <path d="M14.8038 17L11.3397 15" stroke="#d59448" stroke-width="2"/>
    </svg>
    <span class="brand-name">SUPPLY<span class="gold">VALID</span><span class="gold">.</span></span>
  </div>

  <div class="nav-links d-none d-md-flex align-items-center gap-4">
    <a href="#features" class="nav-link-item">Features</a>
    <a href="#about" class="nav-link-item">About</a>
    <a href="#contact" class="nav-link-item">Contact</a>
  </div>

  <!-- Login route commented out, button disabled temporarily -->
  <button class="btn-signin" disabled title="Coming soon">
    Sign In
  </button>
</nav>

<!-- Hero -->
<section class="hero d-flex align-items-center">
  <div class="container-fluid px-4 px-md-5">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <p class="hero-label mb-2">Identity & Access Management</p>
        <h1 class="hero-title">
          One Identity.<br/>
          Every Platform.<br/>
          <span class="gold">Zero Friction.</span>
        </h1>
        <p class="hero-sub mt-4">
          SupplyValid SSO secures access across CAPITAL, SOVRN, and SVN —
          with role-based control, multi-region support, and enterprise-grade security.
        </p>
        <div class="d-flex gap-3 mt-5 flex-wrap">
          <button class="btn-primary-cta" disabled title="Coming soon">
            <i class="pi pi-sign-in me-2"></i>Get Started
          </button>
          <a href="#features" class="btn-outline-cta">
            <i class="pi pi-info-circle me-2"></i>Learn More
          </a>
        </div>
        <p class="mt-4 built-tag">
          <span class="flag-in">🇮🇳</span> Built in India &nbsp;·&nbsp;
          <span class="flag-us">🌐</span> Built for the World
        </p>
      </div>

      <div class="col-lg-6 d-none d-lg-flex justify-content-center">
        <div class="hero-graphic">
          <div class="hex-ring ring-1"></div>
          <div class="hex-ring ring-2"></div>
          <div class="hex-ring ring-3"></div>
          <svg class="center-logo" width="120" height="120" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2L35.5885 11V29L20 38L4.41154 29V11L20 2Z" stroke="#d59448" stroke-width="1.5"/>
            <circle cx="20" cy="20" r="4" fill="#d59448"/>
            <path d="M20 10V14" stroke="#d59448" stroke-width="2"/>
            <path d="M20 26V30" stroke="#d59448" stroke-width="2"/>
            <path d="M28.6603 15L25.1962 17" stroke="#d59448" stroke-width="2"/>
            <path d="M14.8038 23L11.3397 25" stroke="#d59448" stroke-width="2"/>
            <path d="M28.6603 25L25.1962 23" stroke="#d59448" stroke-width="2"/>
            <path d="M14.8038 17L11.3397 15" stroke="#d59448" stroke-width="2"/>
          </svg>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Stats Bar -->
<section class="stats-bar">
  <div class="container-fluid px-4 px-md-5">
    <div class="row text-center">
      <div class="col-4">
        <div class="stat-value">3</div>
        <div class="stat-label">Platforms</div>
      </div>
      <div class="col-4">
        <div class="stat-value">2</div>
        <div class="stat-label">Regions</div>
      </div>
      <div class="col-4">
        <div class="stat-value">SSO</div>
        <div class="stat-label">Unified Auth</div>
      </div>
    </div>
  </div>
</section>

<!-- Features -->
<section class="features-section" id="features">
  <div class="container-fluid px-4 px-md-5">
    <div class="section-header text-center mb-5">
      <p class="section-label">What We Offer</p>
      <h2 class="section-title">Built for enterprise.<br/>Simple to manage.</h2>
    </div>

    <div class="row g-4">
      <div class="col-md-6 col-lg-4" *ngFor="let f of features">
        <div class="feature-card">
          <div class="feature-icon">
            <i class="pi {{ f.icon }}"></i>
          </div>
          <h5 class="feature-title">{{ f.title }}</h5>
          <p class="feature-desc">{{ f.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- About / CTA -->
<section class="cta-section" id="about">
  <div class="container-fluid px-4 px-md-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <p class="section-label">About SupplyValid</p>
        <h2 class="cta-title">
          Securing supply chain identity,<br/>
          <span class="gold">one token at a time.</span>
        </h2>
        <p class="cta-sub mt-3">
          SupplyValid is a supply chain intelligence company. Our SSO platform is the
          backbone that connects teams, clients, and platforms — keeping data secure
          and access seamless across every node of the supply chain.
        </p>
      </div>
      <div class="col-lg-5 d-flex justify-content-lg-end mt-4 mt-lg-0">
        <div class="cta-box">
          <h4 class="mb-2">Ready to access the portal?</h4>
          <p class="text-muted small mb-4">Contact your administrator for credentials.</p>
          <button class="btn-primary-cta w-100" disabled title="Coming soon">
            <i class="pi pi-sign-in me-2"></i>Sign In to Portal
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="sv-footer" id="contact">
  <div class="container-fluid px-4 px-md-5">
    <div class="row align-items-center">
      <div class="col-md-4 mb-3 mb-md-0">
        <div class="d-flex align-items-center gap-2">
          <svg width="22" height="22" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 2L35.5885 11V29L20 38L4.41154 29V11L20 2Z" stroke="#d59448" stroke-width="2.5"/>
            <circle cx="20" cy="20" r="4" fill="#d59448"/>
            <path d="M20 10V14" stroke="#d59448" stroke-width="2"/>
            <path d="M20 26V30" stroke="#d59448" stroke-width="2"/>
            <path d="M28.6603 15L25.1962 17" stroke="#d59448" stroke-width="2"/>
            <path d="M14.8038 23L11.3397 25" stroke="#d59448" stroke-width="2"/>
            <path d="M28.6603 25L25.1962 23" stroke="#d59448" stroke-width="2"/>
            <path d="M14.8038 17L11.3397 15" stroke="#d59448" stroke-width="2"/>
          </svg>
          <span class="brand-name-sm">SUPPLY<span class="gold">VALID</span><span class="gold">.</span></span>
        </div>
        <p class="footer-sub mt-2">Identity & Access Management</p>
      </div>

      <div class="col-md-4 text-md-center mb-3 mb-md-0">
        <div class="footer-links d-flex flex-wrap gap-3 justify-content-md-center">
          <a href="#" class="footer-link">Privacy Policy</a>
          <a href="#" class="footer-link">Terms of Use</a>
          <a href="#" class="footer-link">Help & Support</a>
        </div>
      </div>

      <div class="col-md-4 text-md-end">
        <p class="footer-copy">© 2026 SupplyValid. All rights reserved.</p>
        <p class="footer-copy">🇮🇳 Made in India</p>
      </div>
    </div>
  </div>
</footer>
